module.exports = __webpack_public_path__ + "static/media/MongoDB-logo.fae318ed.png";